import type { ReactElement } from 'react';
import { SitePageShell } from '@/shared/ui';
import { MyPageHeader } from '@/widgets/my-page-header';
import { MyPageNav } from '@/widgets/my-page-nav';
import { MyProfilePanel } from '@/widgets/my-profile-panel';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 회원정보(/my/profile) — 계정 정보·인증 상태·비밀번호 재설정. 큰 "My Page" 머리 아래 왼쪽(좁은 화면은 위) 메뉴와 본문을 놓는다. */
export const MyProfilePage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
    <MyPageHeader />
    <div className="mt-8 grid gap-10 sm:mt-12 lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[15rem_minmax(0,1fr)] xl:gap-20">
      <MyPageNav activeId="profile" />
      <MyProfilePanel />
    </div>
  </SitePageShell>
);
